import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

export type ClearLlmRunsAction = {
  type: WorkflowsActionTypes["LLM_RUNS_CLEAR"]["SUCCESS"];
};

export default function clearLlmRuns() {
  return {
    type: ActionTypes.LLM_RUNS_CLEAR.SUCCESS,
  };
}
